import React, { useState } from 'react';
import { Calendar, FileText } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { TabNav } from '../../components/ui/TabNav';
import { PageHeader } from '../../components/ui/PageHeader';
import { PerformancesTab } from './PerformancesTab';
import { ServiceCatalogTab } from './ServiceCatalogTab';
import { usePermissions } from '../../hooks/usePermission';

const TABS = [
  { id: 'performances', label: 'Prestazioni', icon: <Calendar size={15} /> },
  { id: 'catalog',      label: 'Listino',     icon: <FileText size={15} /> },
];

const TOGGLE_STYLE = {
  group: { display: 'inline-flex' as const, gap: 0, borderRadius: 'var(--radius-card)', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.10)' },
  btn: (active: boolean): React.CSSProperties => ({
    padding: '0.375rem 0.875rem', fontSize: 'var(--text-sm)', fontWeight: active ? 600 : 400,
    border: 'none', cursor: 'pointer', outline: 'none',
    background: active ? 'var(--color-primary)' : 'var(--glass-bg-card)',
    color: active ? '#fff' : 'var(--color-text)',
  }),
};

export default function PerformancesPage() {
  const { hasPermission, isLoading } = usePermissions();
  const canView = hasPermission('performances.view');
  const canMyView = hasPermission('performances.my.view');
  const canCatalogView = hasPermission('performances.catalog.view');
  const canAllView = hasPermission('performances.all.view');
  const [tab, setTab] = useState('performances');
  const [scope, setScope] = useState<'my' | 'all'>('my');

  if (isLoading) return null;
  if (!canView && !canMyView) return <Navigate to="/tasks" replace />;

  const visibleTabs = TABS.filter(t => t.id !== 'catalog' || canCatalogView);

  return (
    <div className="page-enter" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <PageHeader title="Prestazioni" />
      <TabNav tabs={visibleTabs} active={tab} onChange={setTab} />
      {tab === 'performances' && (
        <>
          {canAllView && (
            <div style={TOGGLE_STYLE.group}>
              <button style={TOGGLE_STYLE.btn(scope === 'my')} onClick={() => setScope('my')}>Mie</button>
              <button style={TOGGLE_STYLE.btn(scope === 'all')} onClick={() => setScope('all')}>Tutte</button>
            </div>
          )}
          <PerformancesTab scope={scope} />
        </>
      )}
      {tab === 'catalog' && canCatalogView && <ServiceCatalogTab />}
    </div>
  );
}
